import React from 'react'
import { Link } from 'react-router-dom'

export default function Logo() {
  return (
    <Link to={'/'}>
        <h2 className='logo'>🅵🅰🅺🅴🆂🆃🅾🆁🅴</h2>
    </Link>
  )
}
